import { Box, Container } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { useConferenceConfig } from './ConferenceConfigContext';

export default function Header() {
  const { config } = useConferenceConfig();

  return (
    <>
      {config.bannerImageUrl ?
        <Box component="img" className="Banner" src={config.bannerImageUrl} alt={config.name || "College Conference"}
          sx={{ objectFit: 'cover', width: '100%', display: 'block', maxHeight: 420 }} />
        : null}
      <Container sx={{ pt: 4, pb: 2 }}>
        <Box
          sx={{
            maxWidth: 720,
            mx: 'auto',
            textAlign: 'left',
            color: 'text.secondary',
            '& p': { lineHeight: 1.7, fontSize: '1.05rem' },
            '& h1, & h2, & h3': { color: 'text.primary', fontWeight: 700 },
            '& h1': { textAlign: 'center' },
            '& ul, & ol': { paddingLeft: '1.25em' },
          }}
        >
          <ReactMarkdown>{config.headerMarkdown || ''}</ReactMarkdown>
        </Box>
      </Container>
    </>
  );
}
